import { render } from "./ClockIcon.vue?vue&type=template&id=6905e5ee"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ClockIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6905e5ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6905e5ee', __exports__)) {
    api.reload('6905e5ee', __exports__)
  }
  
  module.hot.accept("./ClockIcon.vue?vue&type=template&id=6905e5ee", () => {
    api.rerender('6905e5ee', render)
  })

}


export default __exports__